"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MainContainer = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var theme_1 = __importDefault(require("../../../../theme"));
var MainContainer = styled_components_1.default.p(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-align: center;\n  margin: 5px 10px;\n  font-size: ", ";\n  color: ", ";\n"], ["\n  text-align: center;\n  margin: 5px 10px;\n  font-size: ", ";\n  color: ",
    ";\n"])), theme_1.default.fontSizes.small, function (_a) {
    var active = _a.active, color = _a.color;
    return active
        ? color || theme_1.default.colorsPalette.blue.default
        : theme_1.default.colorsPalette.gray.default;
});
exports.MainContainer = MainContainer;
var templateObject_1;
//# sourceMappingURL=styles.js.map